import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import SettingsTitle from '../../UIElements/SettingsTitle';
import { WEB_API_ACCOUNT_NAV } from '../../../../assets/constants/strings';
import { FaEdit, FaTimesCircle, FaCheckCircle } from 'react-icons/fa';
import Loader from '../../../Loader';
import { updateUserInfo } from '../../../../store/User/userActions';
import $ from 'jquery';
import ChangePassword from './ChangePassword';
import axios from 'axios';
import './style.scoped.scss';

const mapStateToProps = (state) => ({
  user: state.user.user,
  userError: state.user.userError,
  loading: state.user.loading,
});

const mapDispatchToProps = { updateUserInfo };

const UserInfo = ({ user, userError, updateUserInfo, loading }) => {
  const [firstName, setFirstName] = useState(user.firstName);
  const [lastName, setLastName] = useState(user.lastName);
  const [email] = useState(user.email);
  const [organisationName, setOrganisationName] = useState(user.organisation);
  const [orgAdress, setOrgAdress] = useState(user.address ? user.address : '');
  const [orgTaxId, setOrgTaxId] = useState(user.orgTaxId ? user.orgTaxId : '');
  const [taxId, setTaxId] = useState(user.orgTaxId ? user.orgTaxId : '');
  const [formDisabled, setFormDisabled] = useState(true);
  const [invalidEdit, setInvalidEdit] = useState(false);
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState('');
  const [validationResult, setValidationResult] = useState('');
  const [addressError, setAddressError] = useState(true);
  const [addressFocus, setAddressFocus] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Add event listener when the component mounts
    document.addEventListener('click', handleDocumentClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [addressFocus, selectedAddress, addressError]);

  const handleDocumentClick = (e) => {
    // Check if the click event occurred outside of the dropdown container
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      if (!selectedAddress && addressFocus && addressError) {
        setValidationResult('Please select a valid address');
        setAddressError(true);
      } else setValidationResult('');
      setSuggestions([]); // Close the dropdown
    }
  };

  const handleChange = async (e) => {
    const inputValue = e.target.value;
    setQuery(inputValue);

    if (inputValue.trim() === '') {
      setSuggestions([]);
      return;
    }

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${inputValue}&key=AIzaSyCeeIv1CTRBO7EjKhoSJ0WQs9axK4hJhHs`
      );

      if (response.data.predictions) {
        setSuggestions(response.data.predictions);
      }
    } catch (error) {
      console.error('Error fetching address suggestions:', error);
    }
  };

  const handleSelectAddress = async (address) => {
    setQuery(address.description);
    setSuggestions([]);

    try {
      const geocodeResponse = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${address.description}&key=AIzaSyCeeIv1CTRBO7EjKhoSJ0WQs9axK4hJhHs`
      );

      if (geocodeResponse.data.status === 'OK') {
        setAddressError(false);
        setSelectedAddress(address.description);
      } else {
        setAddressError(true);
        setValidationResult('Invalid address');
      }
    } catch (error) {
      console.error('Error validating address:', error);
    }
  };

  const handleEditUser = (e) => {
    e.preventDefault();

    if (
      user.firstName === firstName &&
      user.lastName === lastName &&
      user.organisation === organisationName &&
      user.taxId === taxId
    ) {
      setInvalidEdit(true);
      return;
    } else {
      updateUserInfo({
        id: user.userID,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
      });
    }
    setFormDisabled(true);
  };

  const handleResetForm = () => {
    setFormDisabled(true);
    setInvalidEdit(false);
    setFirstName(user.firstName);
    setLastName(user.lastName);
    setOrganisationName(user.organisation);
    setOrgAdress(user.orgTaxId);
    setOrgTaxId(user.orgTaxId);
  };

  return (
    <div id='account-info'>
      <SettingsTitle title={WEB_API_ACCOUNT_NAV.INFO.TITLE} />
      {loading ? (
        <div className='inner-load'>
          <Loader />
        </div>
      ) : (
        <form onSubmit={handleEditUser} className='user-form'>
          <div className='user-form__row'>
            <div className='form-group'>
              <label htmlFor='firstName'>First Name</label>
              <input
                id='firstName'
                className='form-control'
                type='text'
                minLength={2}
                value={firstName}
                onChange={(e) => {
                  if (!formDisabled) {
                    setFirstName(e.target.value);
                    if (invalidEdit) setInvalidEdit(false);
                    if (
                      e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                      e.target.value.length < 2
                    ) {
                      e.target.setCustomValidity(
                        'Please enter a valid first name.'
                      );
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                disabled={formDisabled}
                required
              />
            </div>
            <div className='form-group'>
              <label htmlFor='lastName'>Last Name</label>
              <input
                id='lastName'
                className='form-control'
                type='text'
                minLength={3}
                value={lastName}
                onChange={(e) => {
                  if (!formDisabled) {
                    setLastName(e.target.value);
                    if (invalidEdit) setInvalidEdit(false);
                    if (
                      e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                      e.target.value.length < 3
                    ) {
                      e.target.setCustomValidity(
                        'Please enter a valid last name.'
                      );
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                disabled={formDisabled}
                required
              />
            </div>
          </div>
          <div className='user-form__row mb-5'>
            <div className='form-group wf-hover'>
              <label htmlFor='email'>Email</label>
              <input
                id='email'
                className='form-control'
                type='text'
                value={email}
                disabled
              />
              <span
                className='wf-hover__text'
                title='Your email address is your unique identifier in RegulationCity, therefore, it cannot be changed.'
              >
                Cannot be Edited
              </span>
            </div>
            <div className='d-flex flex-column'>
              <label className='mb-0'>Password</label>
              <button
                type='button'
                onClick={() => $('#passwordModal').modal('show')}
                className='my-account-btn secondary ml-0'
              >
                Change Password
              </button>
            </div>
          </div>
          <SettingsTitle title='Company Details' />
          <div className='user-form__row'>
            <div className='form-group'>
              <label htmlFor='organisationName'>Organisation Name</label>
              <input
                id='organisationName'
                className='form-control'
                type='text'
                minLength={2}
                value={organisationName}
                onChange={(e) => {
                  if (!formDisabled) {
                    setOrganisationName(e.target.value);
                    if (invalidEdit) setInvalidEdit(false);
                    if (
                      e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                      e.target.value.length < 2
                    ) {
                      e.target.setCustomValidity(
                        'Please enter a valid first name.'
                      );
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                disabled={formDisabled}
                required
              />
            </div>
            <div className='form-group'>
              <label htmlFor='taxId'>Business Tax ID</label>
              <input
                id='taxId'
                className='form-control'
                type='text'
                minLength={3}
                value={taxId}
                onChange={(e) => {
                  if (!formDisabled) {
                    setTaxId(e.target.value);
                    if (invalidEdit) setInvalidEdit(false);
                    if (
                      e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                      e.target.value.length < 3
                    ) {
                      e.target.setCustomValidity(
                        'Please enter a valid Tax ID.'
                      );
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                disabled={formDisabled}
                required
              />
            </div>
          </div>
          <div className='user-form__row' ref={dropdownRef}>
            <div className='form-group addressDropdown'>
              <label htmlFor='organisationName'>Organisation Address</label>
              <input
                type='text'
                className='form-control'
                placeholder='Enter an address'
                value={query}
                onChange={handleChange}
                disabled={formDisabled}
                onBlur={() => setAddressFocus(true)}
              />
              {suggestions && suggestions.length > 0 ? (
                <ul>
                  {suggestions.map((suggestion) => (
                    <li
                      key={suggestion.place_id}
                      onClick={() => handleSelectAddress(suggestion)}
                    >
                      {suggestion.description}
                    </li>
                  ))}
                </ul>
              ) : null}
              {validationResult && <p>{validationResult}</p>}
            </div>
          </div>
          {invalidEdit && (
            <label id='NoChange' className='my-3'>
              * No field was updated. Please update any of the fields in order
              to proceed or click "Cancel" to exit editing.
            </label>
          )}
          {userError && !loading && (
            <span className='text-danger my-3 font-weight-bold'>
              {userError.reason}
            </span>
          )}
          {invalidEdit && (
            <label id='NoChange' className='my-3'>
              * No field was updated. Please update any of the fields in order
              to proceed or click "Cancel" to exit editing.
            </label>
          )}
          {formDisabled ? (
            <button
              type='button'
              className='my-account-btn d-flex align-items-center'
              onClick={() => setFormDisabled(false)}
            >
              <FaEdit className='mr-2' />
              Edit
            </button>
          ) : (
            <div className='d-flex'>
              <button
                type='reset'
                className='my-account-btn secondary d-flex align-items-center'
                onClick={handleResetForm}
              >
                <FaTimesCircle className='mr-2' />
                Cancel
              </button>
              <button
                type='submit'
                className='my-account-btn d-flex align-items-center'
              >
                <FaCheckCircle className='mr-2' />
                Save
              </button>
            </div>
          )}
        </form>
      )}
      <ChangePassword />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
